module.exports = __webpack_public_path__ + "static/media/ads-preview.2477ae7b.jpg";